import { Injectable } from "@angular/core";
import {
  ExportContext,
  ExportFileFormat,
  ExportRange,
  ExportService,
  ExportTaskProcessor,
} from "app/layout/export-overlay";
import { SalesDistributionService } from "../sales-distribution.service";
import { IMaterialListItem } from "../interfaces/order_material.interface";
import get from "lodash-es/get";
import ceil from "lodash-es/ceil";
import {
  LOCALIZED_PROPERTIES,
  SALE_DISRIBUTION_EXPORT_ID,
  SALE_DISTRIBUTION_EXPORT_TITLE,
} from "./distribution.constants";
import { IOptionFilterDistribution } from "../interfaces/option_filter.interface";
import { takeUntil } from "rxjs";

@Injectable()
export class DistributionExport {
  constructor(
    private exportService: ExportService,
    private distributionService: SalesDistributionService
  ) {}

  private transforItem(order: any, material: IMaterialListItem) {
    const dataFormat = {
      code: get(order, "soldTo.externalKeys.code", "??"),
      client: get(order, "soldTo.name", "??"),
      codeDelivery: get(order, "shipTo.externalKeys.code", "??"),
      delivery: get(order, "shipTo.name", "??"),
      codeMaterial: get(material, "material.code", "??"),
      material: get(material, "material.name", "??"),
      um:
        material.selected === 1
          ? get(material, "baseUnitOfMeasure.code", "??")
          : get(material, "pararellUnitOfMeasure.code", "??"),
      price: get(order, "unitPrice", "??"),
      amountRequest: get(order, "baseQuantity", "??"),
      amountSeved: get(order, "soldQuantitySuggested", "0") || "0",
    };

    return dataFormat;
  }

  protected setAsActiveOrInactive(value: any) {
    return ExportTaskProcessor.types.boolean(value, {
      trueText: "Activo",
      falseText: "Inactivo",
    });
  }

  export(
    format: ExportFileFormat,
    range: ExportRange,
    totalItems: number,
    pageSize: number,
    pageIndex: number,
    filter: IOptionFilterDistribution
  ) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService
      .task({
        id: SALE_DISRIBUTION_EXPORT_ID,
        title: SALE_DISTRIBUTION_EXPORT_TITLE,
        format: format,
        iterations: range === ExportRange.AllPages ? totalPages : 1,
        start: (ctx: ExportContext) => {
          ctx.processor.localizeItemProperties(
            SALE_DISTRIBUTION_EXPORT_TITLE,
            LOCALIZED_PROPERTIES
          );
        },
        next: (ctx: ExportContext) => {
          const currentPage =
            range === ExportRange.AllPages ? ctx.iteration : pageIndex;
          this.distributionService
            .findPaginationDistribution(
              { ...filter, indexPage: currentPage },
              { contextHeader: "export" }
            )
            .pipe(takeUntil(ctx.stopped))
            .subscribe((res) => {
              get(res, "data.materialList", []).map((item) =>
                get(item, "orderList", []).map((order) => {
                  const transform = this.transforItem(order, item);

                  ctx.processor.addToSection(
                    SALE_DISTRIBUTION_EXPORT_TITLE,
                    transform
                  );
                })
              );
              ctx.next();
            });
        },
      })
      .start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(SALE_DISRIBUTION_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
